import {combineReducers} from "redux";
import messages from "./messages";
import signtasks from "./signtasks";
import templates from "./templates";

export default combineReducers({
  messages,
  signtasks,
  templates
});
